import { TriforceIcon } from './TriforceIcon';

/**
 * author: Austin Andrews
 * id 835C3AA9-800B-4767-BDED-97FB875B19DF
 * name triforce
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triforce.svg
 * tags
 * - Gaming / RPG 
 */
export const ZeldaIcon = TriforceIcon;
export default ZeldaIcon